export default __webpack_public_path__ + "static/media/favicon.eef01dc7.ico";